export default __webpack_public_path__ + "static/media/search-gray.c65e6d50.svg";